export type DemoRequestFormFields = {
  email: string;
  phone?: string;
  schedule: string;
};

export const SCHEDULE_MORNING = 'morning';
export const SCHEDULE_EVENING = 'evening';
